import * as React from 'react';
import * as learn from "./style.module.scss";
export const Learn = () => {
  return (
    <section className={learn.learn}>
      <div className="container">
        <h2>Собираетесь освоить профессию в IT?</h2>
        <p className={learn.desc}>Наш курс поможет вам легко запомнить и научиться применять<br/> английскую IT-лексику.</p>
        <ul>
          <li className={learn.titleEl}>
            <h3>Чему вы научитесь:</h3>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/icon-nau-02.png" alt=""/>
            <p>Понимать и использовать основные IT-термины на русском языке</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/icon-nau-03.png" alt=""/>
            <p>Понимать базовые фразы IT-специалистов на английском языке</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/icon-nau-04.png" alt=""/>
            <p>Читать и понимать базовые тексты в IT на английском</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/icon-nau-05.png" alt=""/>
            <p>Общаться на основные темы в IT на базовом уровне</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/icon-nau-06.png" alt=""/>
            <p>Формировать базовые запросы и искать информацию на английском языке</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
